module.exports = __webpack_public_path__ + "static/media/Embody - Dreamin (ft. Camden Cox).abc0b1c0.mp3";